import React from 'react';
import { KeyValueView } from 'commons-ui';

import { IRefundSuggestionProps } from '../types';
import useUserProfileActions from '../../../useUserProfileActions';
import { getKeyConfig } from './useRefundSuggestion';
import { makeActionHandler, makeActionList } from './actions';

const RefundSuggestion: React.FC<IRefundSuggestionProps> = (props) => {
	const { keyConfig, keyValueLayout, refundSuggestionDetails } = getKeyConfig(props);
	const { getActionHandler, getActionList } = useUserProfileActions(makeActionHandler, makeActionList, {
		refundSuggestionDetails,
		tournamentDetails: { ...props }
	});

	return (
		<>
			<KeyValueView
				keyConfig={keyConfig}
				keyValueLayout={keyValueLayout}
				getActionHandler={getActionHandler}
				getActionList={getActionList}
			/>
		</>
	);
};

export default RefundSuggestion;
